import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import t from '@sprinx/translate';
export var formatMessage = function formatMessage(error, label) {
  var rx = /\$field\$/g;
  var msg = rx.test(error) ? error.replace(rx, label || '') : error;
  return {
    msg: msg
  };
};
/**
 * Prevede vstupni hodnoty textove chyby, helperTextu a labelu do podoby vhodne pro field.
 *
 * @param {Object} props
 * @param {string} [props.error]
 * @param {string} [props.helperText]
 * @param {string} [props.label]
 *
 * @returns {Tuple} `[isError: boolean, helperTextOrErrorMessage: string]`
 */

export default function fieldErrorAndHelperText(props) {
  var error = props.error,
      helperText = props.helperText,
      label = props.label;
  var isError = !!error;
  var helperTextOrErrorMessage = isError && typeof error === 'string' ? t('components/textField/errorMsgWrapper', formatMessage(error, label)) : helperText;
  return [isError, helperTextOrErrorMessage];
}